import { api } from 'api';
import { call, put, SagaReturnType } from 'redux-saga/effects';
import { actionActions } from 'store/data/action';
import { JwtFeature } from 'utility/jwt';

import { operationWrapper } from './operationWrapper';

// Fetches improvement actions and loads the action domain.
// Gated behind JwtFeature.Improvements.
export function* initializeActions() {
  function* work(tenantId: string) {
    const { actionDomain }: SagaReturnType<typeof api.getActions> = yield call(
      api.getActions,
      { tenantId },
    );

    yield put(actionActions.setDomain(actionDomain));
  }

  yield call(operationWrapper, work, JwtFeature.Improvements);
}
